const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request`);

// 接口文档地址：
// http://219.128.52.2:8061/project/11/interface/api/3825
const web_common_getCurrentUserAuditStatus = () => {
  const p = {
    method: 'post',
    urlSuffix: '/web/common/getCurrentUserAuditStatus',
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .then(function (data) {
      return Q.resolve(data);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    })
    ;

};
module.exports = web_common_getCurrentUserAuditStatus;
